import { render, staticRenderFns } from "./PatientAppointmentsModal.vue?vue&type=template&id=56e2fa59&"
import script from "./PatientAppointmentsModal.vue?vue&type=script&lang=js&"
export * from "./PatientAppointmentsModal.vue?vue&type=script&lang=js&"
import style0 from "./PatientAppointmentsModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports